import React from 'react';

interface TitleEditorProps {
  onChange: (title: string) => void;
}

const TitleEditor: React.FC<TitleEditorProps> = ({ onChange }) => {
  return (
    <div className='my-8'>
      <h1 className='font-semibold mb-2 text-xl'>Type your title below</h1>
      <input
        type='text'
        id='title'
        maxLength={25}
        placeholder='Title'
        className='text-xl h-10 sm:w-96 pl-2'
        onChange={(e) => onChange(e.target.value)}
      ></input>
    </div>
  );
};

export default TitleEditor;
